import { USE_BLS_THEME } from '@constants';
import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import { createContext, FC, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { AppTheme, BLS_THEME, PROBONIO_THEME } from './theme';

interface Props {
  children: React.ReactNode;
}

export const ThemeProviderContext = createContext<AppTheme>({} as AppTheme);

export default function useTheme() {
  return useContext(ThemeProviderContext);
}

export const ThemeProvider: FC<Props> = ({ children }) => {
  const { t } = useTranslation();
  const activeTheme = USE_BLS_THEME ? BLS_THEME() : PROBONIO_THEME();

  useEffect(() => {
    document.title = t(`app.title${activeTheme.name}`);
    document.body.classList.add(`theme-${activeTheme.name.toLowerCase()}`);
  }, [activeTheme.name, t]);

  return (
    <ThemeProviderContext.Provider value={activeTheme}>
      <MuiThemeProvider theme={activeTheme.theme}>{children}</MuiThemeProvider>
    </ThemeProviderContext.Provider>
  );
};
